import { defineComponent as _defineComponent } from 'vue';
import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-46b75853"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "CG_main"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"main-title\" data-v-46b75853><div class=\"title\" data-v-46b75853>信息安全保障措施说明</div><div class=\"date\" data-v-46b75853>2017-07-28</div></div><div class=\"content\" data-v-46b75853><div data-v-46b75853>系统信息安全保障措施：</div><br data-v-46b75853><div data-v-46b75853> 阳光人寿针对采用异步文件传输的方式采用VPN或者专线的方式进行数据传输，存放数据的服务器都是阳光内网的服务器。只对合作的渠道开放权限和接口。数据传输过程中会进行MD5的数据加密和数据正确性的验证功能。对于实时传输的数据，会对实时接口传递的报文进行加密和数据正确性验证，存放数据的服务器都是阳光内网的服务器,内部只对合作的渠道开放权限和接口。 </div><br data-v-46b75853><div data-v-46b75853> 阳光人寿采集的客户信息，特别是联系电话和联系地址的用途，包括但不限于用于计算保费、核保、寄送保单和客户回访等。本公司在对投保人，被保险人个人信息严格保密的基础上，因业务需要对投保人或被保险人之个人资料，有搜集、计算机处理、传递的权利。本公司承诺未经客户同意，不会将客户信息用于第三方机构的销售活动。 </div><br data-v-46b75853><div data-v-46b75853>投保人（被保险人或受益人）个人信息、投保信息安全保障措施：</div><br data-v-46b75853><div data-v-46b75853> 您投保时填写的各项信息只作为审核投保申请及评估相关理赔申请的依据， 阳光人寿保险股份有限公司将严格按照国家相关的法律法规对您填写的个人资料承担保密义务，并通过防火墙隔离、数据备份等技术手段，确保您的个人信息、投保信息的安全。 </div></div>", 2);
const _hoisted_4 = [_hoisted_2];
import { useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'Safety',
  setup(__props) {
    const router = useRouter();
    const messageUrl = process.env.VUE_APP_INFORMATION_SAFETY;
    // const handleClose = () => {
    //     // router.push({
    //     //     path: '/informationSafety',
    //     // })
    //     router.go(-1)
    // }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
    };
  }
});